__turbopack_context__.v({
  "className": "gothambold_6065db74-module__a1qG2a__className",
});
